
export default {
  list (state) {
    return state.diaryList
  }
}
